<template>
  <v-app style="background-color: white">
    <div
      class="text-xs-center px-3"
      :class="{
        'custom-content-xs': $vuetify.breakpoint.xsOnly,
        'mt-5': $vuetify.breakpoint.smAndUp,
      }"
    >
      <!-- <v-flex xs12 pb-4> 
        <v-avatar color="red" large>
          <v-icon dark large> &emsp;close&emsp;</v-icon>
        </v-avatar>
      </v-flex> -->
      <div class="xs12 subheading pb-2" style="color: #757575; line-height: 2">
        {{ text.fail }}
        <br />
        {{ text.click }}
        <router-link
          :to="`/paymentMethods/?linkcode=${$route.query.linkcode}`"
          style="color: #1976d2"
        >
          {{ text.here }}
        </router-link>
        {{ text.for }}
      </div>
    </div>
  </v-app>
</template>

<script>
export default {
  computed: {
    text() {
      let obj = {}
      if (this.$store.state.language == 'EN') {
        obj = {
          fail: 'Fail...',
          click: 'Click',
          here: 'here',
          for: 'for back to homepage',
        }
      } else {
        obj = {
          fail: 'ชำระเงินไม่สำเร็จ',
          click: 'คลิก',
          here: 'ที่นี่',
          for: 'เพื่อกลับสู่หน้าชำระเงิน',
        }
      }
      return obj
    },
  },
}
</script>
